export default function diffInDays(dateA, dateB) {
  const dA = new Date(dateA);
  const dB = new Date(dateB);

  // Zera hora, minuto, segundo, milissegundo para comparar só o dia
  dA.setHours(0, 0, 0, 0);
  dB.setHours(0, 0, 0, 0);

  const diffTime = dB - dA;
  const diffDays = diffTime / (1000 * 60 * 60 * 24);

  return diffDays;
}
